import { useCallback } from 'react'
import React from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IColorPickerProps } from 'components/uiKit/ColorPicker'
import ColorPicker from 'components/uiKit/ColorPicker'

const FieldColorPicker = <V extends string | null = string | null>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IColorPickerProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <ColorPicker {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldColorPicker) as typeof FieldColorPicker
